import React from 'react';
import { GRAINS_MENU } from '../grains.constants';
import MenuScreen from '../../common/components/MenuScreen/MenuScrren';

const MainMenu = () => (
  <MenuScreen title="GRŪDAI" list={GRAINS_MENU} />
);

export default MainMenu;
